import classNames from 'classnames';
import { t } from 'ttag';

import { PaymentMethodEnum } from '@newModels';
import { useRegion } from '@hook/useRegion';
import { Switch } from '@ui/Switch';
import { Image } from '@ui/Image';
import { Button } from '@ui/Button';

import s from './PaymentMethodToggle.sss';

export interface PaymentMethod {
  id: PaymentMethodEnum,
  isEnabled: boolean,
  isHidden: boolean,
  name: string,
  description: string,
  descriptionIfHidden: string,
  icon: string,
}

export interface Props {
  className?: string,
  method: PaymentMethod,
  prepayment: number,
  isSubmitting?: boolean,
  onToggle: (checked: boolean) => void,
  onPayLaterEdit: () => void,
  onSafePaymentEdit: () => void,
}

export const PaymentMethodToggle: React.FC<Props> = ({
  className,
  method,
  prepayment,
  isSubmitting,
  onToggle,
  onPayLaterEdit,
  onSafePaymentEdit,
}) => {
  const { currencyName } = useRegion();

  const {
    id,
    isEnabled,
    isHidden,
    name,
    description,
    descriptionIfHidden,
    icon,
  } = method;
  const descriptionText = isHidden ? descriptionIfHidden : description;

  return (
    (
      <div className={classNames(
        s.root,
        { [s.hidden]: isHidden },
        className,
      )}
      >
        <div className={s.info}>
          <Image
            className={s.icon}
            src={icon}
            width="24"
            height="24"
            alt={name}
          />
          <div className={s.block}>
            <p className={s.name}>
              {name}
            </p>
            {descriptionText && (
            <span className={s.description}>
              {descriptionText}
            </span>
            )}
            {id === PaymentMethodEnum.PayLater && (
            <div>
              <p className={s.prepayment}>
                {t`З передплатою ${prepayment} ${currencyName}`}
              </p>
              <Button
                className={s.editButton}
                theme="text"
                disabled={!isEnabled || isHidden || isSubmitting}
                onClick={onPayLaterEdit}
              >
                {t`Редагувати`}
              </Button>
            </div>
            )}

            {id === PaymentMethodEnum.SafePayment && (
              <Button
                className={s.editButton}
                theme="text"
                disabled={!isEnabled || isHidden || isSubmitting}
                onClick={onSafePaymentEdit}
              >
                {t`Редагувати`}
              </Button>
            )}
          </div>
        </div>
        <Switch
          checked={isEnabled}
          disabled={isHidden || isSubmitting}
          onChange={() => onToggle(!isEnabled)}
        />
      </div>
    )
  );
};
